// // Need to use the React-specific entry point to import createApi
// import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
// import urls from '../urls'; 

// // Define a service using a base URL and expected endpoints
// export const cartApi = createApi({
//   reducerPath: 'cartApi',
//   baseQuery: fetchBaseQuery({ baseUrl: urls.SERVER ,
//     prepareHeaders: (headers) => {
//       const token = localStorage.getItem('token');
//       if (token) {
//         headers.set('Authorization', `Bearer ${token}`); 
//       }
//       return headers;
//     },}),
//   endpoints: (builder) => ({
//     // addCartdetails: builder.mutation({
//     //     query: (data) => {
//     //       return {
//     //         url: "/addCartDetailsByUser",
//     //         method: "POST",
//     //         body: data
//     //       }
//     //     }
//     //   })
//     addCartdetails: builder.mutation({
//     query: (body) => {
//         const token = localStorage.getItem("token");

//         return {
//             url: "/addCartDetailsByUser",
//             method: "POST",
//             body,
//             headers: {
//                 "Content-Type": "application/json",
//                 "Authorization": `Bearer ${token}`
//             }
//         };
//     }
// })
// ,
//     getCardDetailsByUserid: builder.query({
//         query: (id) => {
//           return {
//             url: `/getCartDetailsByUser/${id}`,
//             method: "GET"
//           }
//         }
//       }),
//       changeQuantityById: builder.mutation({
//         query: (data) => {
//           return {
//             url: `/ChangeQuantityById`,
//             method: "POST",
//             body:data
//           }
//         }
//       }),
//       deleteCartById: builder.mutation({
//         query: (id) => {
//           return {
//             url: `/deleteCartDetailsById/${id}`,
//             method: "DELETE"
//           }
//         }
//       }),
//       deleteCartByUserId: builder.mutation({
//         query: (id) => {
//           return {
//             url: `/deleteCartDetailsByUserId/${id}`,
//             method: "DELETE"
//           }
//         }
//       })
//   })
// })

// // Export hooks for usage in functional components, which are
// // auto-generated based on the defined endpoints
// export const { 
//   useAddCartdetailsMutation,
//   useGetCardDetailsByUseridQuery,
//   useChangeQuantityByIdMutation,
//   useDeleteCartByIdMutation,
//   useLazyGetCardDetailsByUseridQuery,
//   useDeleteCartByUserIdMutation
// } = cartApi;





// src/services/cartApi.js
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import urls from '../urls';

// create baseQuery with prepareHeaders to attach Authorization automatically
const baseQuery = fetchBaseQuery({
  baseUrl: urls.SERVER,
  prepareHeaders: (headers) => {
    const token = localStorage.getItem('token');
    if (token) {
      headers.set('Authorization', `Bearer ${token}`);
    }
    return headers;
  },
});

export const cartApi = createApi({
  reducerPath: 'cartApi',
  baseQuery,
  tagTypes: ['Cart'],
  endpoints: (builder) => ({
    addCartdetails: builder.mutation({
      // keep query simple — headers are handled by prepareHeaders above
      query: (body) => ({
        url: '/addCartDetailsByUser',
        method: 'POST',
        body,
      }),
    }),

    getCardDetailsByUserid: builder.query({
      // ensure id passed to backend as number (if backend expects number)
      query: (id) => ({
        url: `/getCartDetailsByUser/${Number(id)}`,
        method: 'GET',
      }),
       providesTags: ['Cart'],
    }),

    changeQuantityById: builder.mutation({
      query: (data) => ({
        url: `/ChangeQuantityById`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Cart'],
    }),

    deleteCartById: builder.mutation({
      query: (id) => ({
        url: `/deleteCartDetailsById/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Cart'],
    }),

    deleteCartByUserId: builder.mutation({
      query: (id) => ({
        url: `/deleteCartDetailsByUserId/${id}`,
        method: 'DELETE',
      }),
    }),
  }),
});

export const {
  useAddCartdetailsMutation,
  useGetCardDetailsByUseridQuery,
  useChangeQuantityByIdMutation,
  useDeleteCartByIdMutation,
  useLazyGetCardDetailsByUseridQuery,
  useDeleteCartByUserIdMutation,
} = cartApi;
